import { render, staticRenderFns } from "./BodyPart.vue?vue&type=template&id=0e73242a&scoped=true&"
import script from "./BodyPart.vue?vue&type=script&lang=js&"
export * from "./BodyPart.vue?vue&type=script&lang=js&"
import style0 from "./BodyPart.vue?vue&type=style&index=0&id=0e73242a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e73242a",
  null
  
)

export default component.exports